// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2lPv8","index":"styles_index__2GC7B"};